import { paymentvouchersearch } from "../../../data/Axios/queries";

// Paginated query for initial load
export const PAYMENT_VOUCHERS_PAGINATED_QUERY = `
  query PaymentVouchersPaginated($pageNumber: Int, $pageSize: Int) {
    paymentVouchersPaginatedFunc(functionparams: { 
      pageNumber: $pageNumber, 
      pageSize: $pageSize 
    }) {
      accountName
      actionBy
      actionedDate
      approvedBy
      approvedDate
      approver
      branchName
      companyId
      createdBy
      createdDate
      creator
      currentPage
      firstRecordInPage
      isActive
      lastRecordInPage
      methodName
      outstandingBalance
      pageSize
      paidAmount
      paymentAccountId
      paymentDate
      paymentMethod
      paymentVoucherId
      purchaseOrderId
      reason
      reference
      rejectedBy
      rejectedDate
      remarks
      totalPages
      totalRecords
      updatedBy
      updatedDate
      updator
      vendorId
      vendorName
      reversedBy
      reversedDate
    }
  }
`;


// Search query with filters
export const SEARCH_PAYMENT_VOUCHERS_QUERY = `
  query SearchPaymentVouchers(
    $searchTerm: String
    $dateFrom: DateTime
    $dateTo: DateTime
    $branchId: Int
    $vendorId: Int
    $paymentMethodId: Int
    $paymentStatus: Int
    $pageNumber: Int
    $pageSize: Int
    $companyId: Int
  ) {
    searchPaymentVouchersFromView(
      functionparams: {
        companyId: $companyId
        branchId: $branchId
        vendorId: $vendorId
        paymentMethodId: $paymentMethodId
        paymentStatus: $paymentStatus
        dateFrom: $dateFrom
        dateTo: $dateTo
        pageNumber: $pageNumber
        pageSize: $pageSize
        searchTerm: $searchTerm
      }
    ) {
      accountName
      actionBy
      actionedDate
      approvedBy
      approvedDate
      approver
      branchName
      companyId
      createdBy
      createdDate
      creator
      currentPage
      firstRecordInPage
      isActive
      lastRecordInPage
      methodName
      outstandingBalance
      pageSize
      paidAmount
      paymentAccountId
      paymentDate
      paymentMethod
      paymentVoucherId
      purchaseOrderId
      reason
      reference
      rejectedBy
      rejectedDate
      remarks
      totalPages
      totalRecords
      updatedBy
      updatedDate
      updator
      vendorId
      vendorName
      reversedBy
      reversedDate
    }
  }
`;

export const PAYMENT_VOUCHER_STATISTICS_QUERY = `
  query PaymentVoucherStatistics {
    paymentVoucherStatistics(
      functionparams: { branchId: null, companyId: null }
    ) {
      totalVouchers
      totalAmount
      paidVouchers
      initialStagesVouchers
      reversedVouchers
      rejectedVouchers
      averageVoucherValue
    }
  }
`;



